/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BankResponseDto } from './bankResponseDto';
import { BranchResponseDto } from './branchResponseDto';
import { MemberBankResponseDto } from './memberBankResponseDto';
import { MemberResponseDto } from './memberResponseDto';
import { PurchaseDetailResponseDto } from './purchaseDetailResponseDto';
import { UserResponseDto } from './userResponseDto';

export interface PurchaseResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  member: MemberResponseDto;
  bulkSaleBranch: BranchResponseDto;
  recordedBy: UserResponseDto;
  /**
   * 2021-10-01T00:00:00Z
   */
  recordedAt: string;
  approvedBy: UserResponseDto;
  /**
   * 2021-10-01T00:00:00Z
   */
  approvedAt: string;
  cashier: UserResponseDto;
  /**
   * 2021-10-01T00:00:00Z
   */
  cashierAt: string;
  branch: BranchResponseDto;
  signatureImageUrl: string;
  purchaseNo: string;
  sumAmount: number;
  status: PurchaseResponseDto.StatusEnum;
  paidBy: PurchaseResponseDto.PaidByEnum;
  paidBankType: PurchaseResponseDto.PaidBankTypeEnum;
  paidToMemberBankId: MemberBankResponseDto;
  paidToBankId: BankResponseDto;
  paidToBankBranchName: string;
  paidToBankAccountNo: string;
  paidToPromptpay: string;
  paidSlipImageUrl: string;
  carLicensePlate: string;
  checkInTime: string;
  checkOutTime: string;
  weightIn: number;
  weightOut: number;
  isBulkSale: boolean;
  purchaseDetails: Array<PurchaseDetailResponseDto>;
  noOfDetail: number;
}
// tslint:disable-next-line:no-namespace
export namespace PurchaseResponseDto {
  export type StatusEnum = 'pending_bulk_sale' | 'pending_review' | 'pending_payment' | 'paid' | 'rejected';
  export const StatusEnum = {
      PendingBulkSale: 'pending_bulk_sale' as StatusEnum,
      PendingReview: 'pending_review' as StatusEnum,
      PendingPayment: 'pending_payment' as StatusEnum,
      Paid: 'paid' as StatusEnum,
      Rejected: 'rejected' as StatusEnum,
  };
  export type PaidByEnum = 'cash' | 'bank';
  export const PaidByEnum = {
      Cash: 'cash' as PaidByEnum,
      Bank: 'bank' as PaidByEnum,
  };
  export type PaidBankTypeEnum = 'saved_account' | 'custom_account' | 'promptpay';
  export const PaidBankTypeEnum = {
      SavedAccount: 'saved_account' as PaidBankTypeEnum,
      CustomAccount: 'custom_account' as PaidBankTypeEnum,
      Promptpay: 'promptpay' as PaidBankTypeEnum,
  };
}
